<!--
 * @Author: shp
 * @Date: 2025-03-19 17:38:00
 * @LastEditTime: 2025-12-08 10:46:10
 * @FilePath: /fengyi/web/src/views/project/Detail.vue
 * @Description: 
-->
<template>
<div class="k-page-content" v-loading="loading">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="项目详情" name="first">
                <div class="k-page-common">
                    <div class="k-common-header" style="padding: 12px;">
                        <div class="proDeTitle">
							<div>
								<span class="t1">项目详情：</span>
								<span class="t2">{{infoData.project.project_name}}（{{infoData.project.project_code}}）- {{infoData.project.customer_id_txt}}（{{infoData.project.project_type_txt}}）</span>
								<span class="t3">{{infoData.project.status_txt}}</span>
							</div>
							<div class="back" @click="goBack()">
								<i class="el-icon-back"></i>返回上一页
							</div>
						</div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="whiteBox" style="padding-bottom: 0;">
                            	<div class="projectDetailTop">
									<div class="tyTitle">
										<p>项目信息</p>
									</div>
									<layoutStep v-if="infoData.project.project_name" :stepinfo="infoData"></layoutStep>
									<div class="projectDetailInfo">
										<div class="base-info-wrap">
											<div class="bg">立项信息</div>
											<div class="row">
												<!-- <div class="column">
													<span class="column-label">项目预算收入</span>
													<span class="column-value red">{{infoData.project.project_budget_revenue}}</span>
												</div> -->
												<div class="column">
													<span class="column-label">所属客户</span>
													<span class="column-value">{{infoData.project.customer_id_txt}}</span>
												</div>
												<div class="column">
													<span class="column-label">客户简称</span>
													<span class="column-value">{{infoData.project.customer_as_txt}}</span>
												</div>
												<div class="column">
													<span class="column-label">是否预付款</span>
													<span class="column-value red">{{infoData.project.is_payment_txt}}</span>
												</div>
												<div class="column">
													<span class="column-label">预付款比例</span>
													<span class="column-value red">{{infoData.project.payment_ratio}}</span>
												</div>
												<!-- <div class="column">
													<span class="column-label">项目预算成本</span>
													<span class="column-value red">{{infoData.project.project_budget_cost}}</span>
												</div>
												<div class="column">
													<span class="column-label">项目利润</span>
													<span class="column-value red">{{infoData.project.project_lr}}</span>
												</div> -->
												<div class="column">
													<span class="column-label">退款中</span>
													<span class="column-value" style="color:#409EFF;">{{infoData.project.tuikuanzhong}} 元</span>
												</div>
												<div class="column">
													<span class="column-label">商务</span>
													<span class="column-value">{{infoData.project.business_docking_id_txt}}</span>
												</div>
												<div class="column">
													<span class="column-label">预计发布日期</span>
													<span class="column-value">{{infoData.project.expected_release_date}}</span>
												</div>
												<div class="column">
													<span class="column-label">预计首款日期</span>
													<span class="column-value">{{infoData.project.expected_receipt_date_start}}</span>
												</div>
												<div class="column">
													<span class="column-label">预计尾款日期</span>
													<span class="column-value">{{infoData.project.expected_receipt_date_end}}</span>
												</div>
												<div class="column">
													<span class="column-label">媒介执行</span>
													<span class="column-value">{{infoData.project.edit_medium_id_txt}}</span>
												</div>
												<div class="column">
													<span class="column-label">客户执行</span>
													<span class="column-value">{{infoData.project.uid_txt}}</span>
												</div>
												<div class="column">
													<span class="column-label">需求附件</span>
													<span class="column-value">
														<template v-if="infoData.project.project_need_imgs && infoData.project.project_need_imgs.length>0">
															<span v-for="(item,index) in infoData.project.project_need_imgs" :key="index">
																<el-link type="primary" :href="item" target="_blank" rel="noopener noreferrer">附件{{index+1}}</el-link>{{index == infoData.project.project_need_imgs.length-1 ? '' : '、'}} 
																<!-- <a style="color:#409EFF;font-weight: bold;" :href="item" target="_blank" download rel="noopener noreferrer">附件{{index+1}}{{index == infoData.project.project_need_imgs.length-1 ? '' : '、'}}</a>-->
															</span>
														</template>
														<template v-else>
															暂无
														</template>
													</span>
												</div>
											</div>
										</div>
										<div class="des">
											<div class="desdemand" style="display: flex;">
												<span>需求说明：</span>
												<div class="maxH">
													<div class="des_main">{{infoData.project.project_need}}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
                            </div>
							<div class="whiteBox projectDetailCenter">
								<el-table
										:data="infoData.jingrong"
										style="width: 100%; margin-top: 10px;"
										ref="table">
									<el-table-column
											align="right"
											prop="type">
									</el-table-column>
									<el-table-column
											align="center"
											prop="sw_lirun"
											label="商务利润">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.sw_lirun}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="bj_chengben"
											label="报价成本">
									</el-table-column>
									<el-table-column
											align="center"
											prop="kh_baojia"
											label="客户报价">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.kh_baojia}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="yi_sk_cost"
											label="已收款金额">
									</el-table-column>
									<el-table-column
											align="center"
											prop="tk_cost"
											label="项目退款">
									</el-table-column>
									<el-table-column
											align="center"
											prop="sjsk_cost"
											label="实际收款金额">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.sjsk_cost}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="ying_sk_cost"
											label="应收金额">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.ying_sk_cost}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="yi_kaipiao_customer_cost"
											label="已开票(客户)">
									</el-table-column>
									<el-table-column
											align="center"
											prop="dc_fandian_sum"
											label="单次返点(总计)">
									</el-table-column>
									<el-table-column
											align="center"
											prop="dc_fandian_ys"
											label="单次返点(已收)">
									</el-table-column>
									<el-table-column
											align="center"
											prop="fandian_kaipiao_fandian_cost"
											label="已开票(返点)">
									</el-table-column>
								</el-table>
								<el-table
										:data="infoData.jingrong_other"
										style="width: 100%; margin-top: 20px;"
										ref="table">
									<el-table-column
											align="right"
											prop="type">
									</el-table-column>
									<el-table-column
											align="center"
											prop="sw_lirunlv"
											label="商务利润率">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.sw_lirunlv}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="zx_cost"
											label="执行价">
									</el-table-column>
									<el-table-column
											align="center"
											prop="zc_cost"
											label="支出金额">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.zc_cost}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="yfk_cost"
											label="已付款金额">
									</el-table-column>
									<el-table-column
											align="center"
											prop="zxmx_tk"
											label="执行明细退款">
									</el-table-column>
									<el-table-column
											align="center"
											prop="sjzc_cost"
											label="退款后支出">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.sjzc_cost}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="sjzc_cost_yf"
											label="退款后已付">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.sjzc_cost_yf}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="yf_cost"
											label="应付金额">
											<template slot-scope="scope">
												<span style="color: #fb5555; font-weight: bold;">{{scope.row.yf_cost}}</span>
											</template>
									</el-table-column>
									<el-table-column
											align="center"
											prop="ysp_cost"
											label="已收票金额">
									</el-table-column>
									<el-table-column
											align="center"
											prop="wsp_cost"
											label="未收票金额">
									</el-table-column>
									<el-table-column
											align="center"
											prop="dc_fandian_sy_ys"
											label="单次返点(应收)">
									</el-table-column>
								</el-table>
							</div>
							<div class="whiteBox projectDetailBottom">
								<el-tabs v-model="bottomActiveName">
								    <el-tab-pane label="执行" name="resource" :key="1"></el-tab-pane>
								    <el-tab-pane label="开票" name="kaipiao" :key="2"></el-tab-pane>
									<el-tab-pane label="收款" name="shoukuan" :key="3"></el-tab-pane>
									<el-tab-pane label="项目结算/合同" name="contract" :key="4"></el-tab-pane>
								</el-tabs>
								<template >
									<div style="margin-top: 15px;" v-if="bottomActiveName == 'resource'">
										<el-table
										        :data="infoData.resource"
										        style="width: 100%;"
												height="500"
										        row-key="id"
												:key="bottomActiveName"
												border
												stripe
										        ref = "tableresource"
												:summary-method="getSummaries"
												:show-summary="show_summary"
												:row-class-name="tableRowClassName"
										        highlight-current-row>
												<el-table-column
												        prop="execute_code"
												        label="执行编码"
														fixed="left"
												        width="260">
												</el-table-column>
												<el-table-column
												        prop="resource_id_txt"
												        label="资源名称"
														fixed="left"
												        width="100">
												</el-table-column>
												<el-table-column
												        prop="platform_id_txt"
												        label="所属平台"
														fixed="left"
												        width="100">
												</el-table-column>
												<el-table-column
														prop="supplier_id_txt"
														label="所属供应商"
														min-width="200">
												</el-table-column>
												<!-- <el-table-column
												        prop="project_id_txt"
												        label="所属项目"
												        min-width="200">
												</el-table-column> -->
												<!-- <el-table-column
												        prop="customer_id_txt"
												        label="所属客户"
												        min-width="200">
												</el-table-column> -->
												<el-table-column
												        prop="is_platform_order_txt"
												        label="是否平台下单"
												        width="120"
														:filters="[{ text: '是', value: 'YES' }, { text: '否', value: 'NO' }]"
														:filter-method="filterPlatform"
														>
												</el-table-column>
												<el-table-column
												        prop="is_point_txt"
												        label="是否返点"
												        width="100"
														:filters="[{ text: '是', value: 'YES' }, { text: '否', value: 'NO' }]"
														:filter-method="filterPoint"
														>
												</el-table-column>
												<el-table-column
												        prop="li_run"
												        label="商务利润(元)"
												        width="120">
												</el-table-column>
												<el-table-column
												        prop="li_run_lv"
												        label="商务利润率"
												        width="100">
												</el-table-column>
												<el-table-column
												        prop="strike_price"
												        label="执行价(元)"
												        width="150">
												</el-table-column>
												<el-table-column
												        prop="zhichu_price"
												        label="支出价(元)"
												        width="150">
												</el-table-column>
												<el-table-column
												        prop="baojia_chengbeng_price"
												        label="成本价格(元)"
												        min-width="150">
												</el-table-column>
												<el-table-column
												        prop="point_price"
												        label="返点金额(元)"
												        width="110">
												</el-table-column>
												<el-table-column
												        prop="quotation_price"
												        label="报价(元)"
												        width="150">
												</el-table-column>
												<!-- <el-table-column
												        prop="kan_price"
												        label="刊例价"
												        width="220">
														<template slot-scope="scope">
															<span class="kNorwap">{{scope.row.kan_price[0]}}</span><br/>
															<span class="kNorwap">{{scope.row.kan_price[1]}}</span>
														</template>
												</el-table-column> -->
												<el-table-column
												        prop="release_method_txt"
												        label="发布方式"
												        width="100">
												</el-table-column>
												<el-table-column
												        prop="release_time"
												        label="预计发布时间"
												        width="120">
												</el-table-column>
												<el-table-column
													label="执行价对比"
													width="120">
													<template slot-scope="scope">
														<el-popover
														  placement="right"
														  width="330"
														  v-if="scope.row.dd_quotation_price_arr.length > 0"
														  trigger="hover">
														    <div class="ressupplier">
																<div class="_row">
																	<div class="str">原执行价</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_strike_price_arr[0]}}</div>
																</div>
																<div class="_row">
																	<div class="str">现执行价</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_strike_price_arr[1]}}</div>
																</div>
															</div>
														    <p class="kNorwap" :style="{color:isColor(scope.row.dd_strike_price),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.dd_strike_price)}}</p>
														</el-popover>
														<p class="kNorwap" v-else :style="{color:isColor(scope.row.dd_strike_price),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.dd_strike_price)}}</p>
													</template>
												</el-table-column>
												<el-table-column
													label="报价对比"
													width="120">
													<template slot-scope="scope">
														<el-popover
														  placement="right"
														  width="330"
														  v-if="scope.row.dd_quotation_price_arr.length > 0"
														  trigger="hover">
														    <div class="ressupplier">
																<div class="_row">
																	<div class="str">原报价</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_quotation_price_arr[0]}}</div>
																</div>
																<div class="_row">
																	<div class="str">现报价</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_quotation_price_arr[1]}}</div>
																</div>
															</div>
														    <p class="kNorwap" :style="{color:isColor(scope.row.dd_quotation_price),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.dd_quotation_price)}}</p>
														</el-popover>
														<p class="kNorwap" v-else :style="{color:isColor(scope.row.dd_quotation_price),'font-weight':'bold'}">{{isUp(scope.row.dd_quotation_price)}}</p>
													</template>
												</el-table-column>
												<el-table-column
													prop="dd_lirun"
													label="利润对比"
													width="120">
													<template slot-scope="scope">
														<el-popover
														  placement="right"
														  width="330"
														  v-if="scope.row.dd_lirun_arr.length > 0"
														  trigger="hover">
														    <div class="ressupplier">
																<div class="_row">
																	<div class="str">原利润</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_lirun_arr[0]}}</div>
																</div>
																<div class="_row">
																	<div class="str">现利润</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_lirun_arr[1]}}</div>
																</div>
															</div>
														    <p class="kNorwap" :style="{color:isColor(scope.row.dd_lirun),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.dd_lirun)}}</p>
														</el-popover>
														<p class="kNorwap" v-else :style="{color:isColor(scope.row.dd_lirun),'font-weight':'bold'}">{{isUp(scope.row.dd_lirun)}}</p>
													</template>
												</el-table-column>
												<el-table-column
													prop="dd_lirun_lv"
													label="利润率对比"
													width="120">
													<template slot-scope="scope">
														<el-popover
														  placement="right"
														  width="330"
														  v-if="scope.row.dd_lirun_lv_arr.length > 0"
														  trigger="hover">
														    <div class="ressupplier">
																<div class="_row">
																	<div class="str">原利润率</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_lirun_lv_arr[0]}}</div>
																</div>
																<div class="_row">
																	<div class="str">现利润率</div>
																	<div class="dashed"></div>
																	<div class="price">{{scope.row.dd_lirun_lv_arr[1]}}</div>
																</div>
															</div>
														    <p class="kNorwap" :style="{color:isColor(scope.row.dd_lirun_lv),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.dd_lirun_lv)}}</p>
														</el-popover>
														<p class="kNorwap" v-else :style="{color:isColor(scope.row.dd_lirun_lv),'font-weight':'bold'}">{{isUp(scope.row.dd_lirun_lv)}}</p>
													</template>
												</el-table-column>
												<el-table-column
												        prop="invoice_type_txt"
												        label="发票信息"
												        width="100">
												</el-table-column>
												<el-table-column
												        prop="remark"
												        label="备注"
												        min-width="180">
												</el-table-column>
												<el-table-column prop="invoicestatus" label="收票状态" width="100"
													:filters="[{ text: '未收票', value: 'no' }, { text: '部分收票', value: 'other' }, { text: '全部收票', value: 'all' }, { text: '错误状态', value: 'none' }]"
													:filter-method="filterinvoicestatus">
													<template slot-scope="scope">
														<p v-if="scope.row.invoicestatus == 'no'" style="color: #409EFF;">未收票</p>
														<p v-if="scope.row.invoicestatus == 'other'" style="color: #409EFF;">部分收票</p>
														<p v-if="scope.row.invoicestatus == 'all'" style="color: #67C23A;">全部收票</p>
														<p v-if="scope.row.invoicestatus == 'none'" style="color: #F56C6C;">错误状态</p>
													</template>
												</el-table-column>
												<el-table-column
												prop="paystatus"
												label="付款状态"
												width="100"
												:filters="[{ text: '未付款', value: 'no' }, { text: '部分付款', value: 'other' },{ text: '全部付款', value: 'all' },{ text: '错误状态', value: 'none' }]"
												:filter-method="filterPaystatus"
												>
													<template slot-scope="scope">
														<p v-if="scope.row.paystatus == 'no'" style="color: #409EFF;">未付款</p>
														<p v-if="scope.row.paystatus == 'other'" style="color: #409EFF;">部分付款</p>
														<p v-if="scope.row.paystatus == 'all'" style="color: #67C23A;">全部付款</p>
														<p v-if="scope.row.paystatus == 'none'" style="color: #F56C6C;">错误状态</p>
													</template>
												</el-table-column>
												<el-table-column
														prop="point_status_txt"
														label="返点状态"
														width="100"
														:filters="[{ text: '无返点', value: 'no_point' }, { text: '未确认', value: 'no_confim' }, { text: '已确认', value: 'yes_confim' }, { text: '部分收款', value: 'other' },{ text: '全部收款', value: 'all' },{ text: '错误状态', value: 'none' }]"
														:filter-method="filterPointstatus"
														>
												</el-table-column>
												<el-table-column
														prop="point_uid_txt"
														label="返点责任人"
														width="110"
													>
												</el-table-column>
												<el-table-column
														prop="point_uid_depar_txt"
														label="返点责任部门"
														width="120"
														>
												</el-table-column>
												<el-table-column
														prop="platform_status_txt"
														label="平台对账"
														align="center"
														width="100"
														:filters="[{ text: '未对账', value: '0' }, { text: '已对账', value: '1' },{ text: '无需对账', value: '2' }]"
														:filter-method="filterPstatus"
														>
												</el-table-column>
												<el-table-column
														fixed="right"
												        prop="status_txt"
												        label="状态"
												        width="80"
														:filters="[{ text: '待提交', value: '1' }, { text: '待审核', value: '2' }, { text: '被驳回', value: '3' }, { text: '正常', value: '4' }, { text: '匹配中', value: '5' }, { text: '已发布', value: '6' }, { text: '供应商对账', value: '7' }, { text: '已作废', value: '8' }, { text: '撤销中', value: '9' }, { text: '待报价', value: '10' }]"
														:filter-method="filterTag"
														>
												</el-table-column>
												<el-table-column
												        prop="create_time"
												        label="创建时间"
												        width="200">
												</el-table-column>
										</el-table>
									</div>
								</template>
								<template >
									<div style="margin-top: 15px;" v-if="bottomActiveName == 'kaipiao'">
										<el-table
										        :data="infoData.kaipiao"
										        style="width: 100%"
										        row-key="id"
												border
												:key="bottomActiveName"
												stripe
										        ref = "tablekaipiao"
										        highlight-current-row>
												<el-table-column
												        prop="project_code"
												        label="所属项目编码"
												        min-width="200">
												</el-table-column>
												<el-table-column
														fixed
														prop="project_name"
														label="所属项目名称"
														min-width="200">
												</el-table-column>
												<el-table-column
												        prop="project_all_price"
												        label="项目金额(元)"
												        width="120">
												</el-table-column>
												<el-table-column
												        prop="invoice_cost"
												        label="开票金额(元)"
												        width="120">
												</el-table-column>
												<el-table-column
												        prop="status_txt"
												        label="状态"
												        width="80">
												</el-table-column>
												<el-table-column
												        prop="create_time"
												        label="创建时间"
												        width="200">
												</el-table-column>
										</el-table>
									</div>
								</template>
								<template >
									<div style="margin-top: 15px;" v-if="bottomActiveName == 'shoukuan'">
										<el-table
										        :data="infoData.shoukuan"
										        style="width: 100%"
										        row-key="id"
												border
												:key="bottomActiveName"
												stripe
										        ref = "tableshoukuan"
										        highlight-current-row>
												<el-table-column
												        prop="project_code"
												        label="所属项目编码"
												        min-width="200">
												</el-table-column>
												<el-table-column
														fixed
														prop="project_name"
														label="所属项目名称"
														min-width="200">
												</el-table-column>
												<el-table-column
												        prop="project_cost"
												        label="项目金额(元)"
												        min-width="150">
												</el-table-column>
												<el-table-column
												        prop="used_cost"
												        label="实际收款金额(元)"
												        width="140">
												</el-table-column>
												<el-table-column
												        prop="num"
												        label="银行明细号"
												        width="200">
												</el-table-column>
												<el-table-column
												        prop="bank_statement_cost"
												        label="银行明细金额(元)"
												        width="140">
												</el-table-column>
												<el-table-column
												        prop="create_time"
												        label="创建时间"
												        width="200">
												</el-table-column>
												<el-table-column
												        prop="status_txt"
												        label="状态"
												        width="80">
												</el-table-column>
										</el-table>
									</div>
								</template>
								<template v-if="bottomActiveName == 'contract'">
									 <el-button :disabled="[8,9,10,11].indexOf(infoData.project.status) != -1" v-if="queryParams.type == 'detail' && infoData.project.project_name" type="primary" :size='size' style="margin-top: 10px;" @click="addOpenInvoice">添加</el-button>
									<div style="margin-top: 10px;">
										<el-table
										        :data="infoData.contract"
										        style="width: 100%"
										        row-key="id"
												border
												:key="bottomActiveName"
												stripe
										        ref = "tablecontract"
										        highlight-current-row>
												<el-table-column
														fixed
														prop="type_txt"
														label="类型"
														width="100">
												</el-table-column>
												<el-table-column
												        prop="contract_code"
												        label="合同编码"
												        min-width="150">
												</el-table-column>
												<el-table-column
												        prop="project_name"
												        label="项目名称"
												        min-width="200">
												</el-table-column>
												<el-table-column
												        prop="related_contracts"
												        label="附件"
												        min-width="120">
														<template slot-scope="scope">
															<template v-if="scope.row.attachment_txt.length>0">
																<span v-for="(item,index) in scope.row.attachment_txt" :key="index">
																	<el-link type="primary" :href="item" target="_blank">附件{{index+1}}</el-link>{{index == scope.row.attachment_txt.length-1 ? '' : '、'}}
																</span>
															</template>
															<template v-else>
																暂无
															</template>
														</template>
												</el-table-column>
												<el-table-column
												        prop="create_time"
												        label="关联时间"
												        width="170">
												</el-table-column>
												<el-table-column
												        prop="sign_start_end_time"
												        label="有效期"
												        min-width="200">
												</el-table-column>
												<el-table-column
												        prop="status_txt"
												        label="状态"
												        width="80">
												</el-table-column>
												<el-table-column
												        fixed="right"
												        label="操作"
														align="center"
												        width="100">
												    <template slot-scope="scope">
												        <el-button type="text" size="small" style="font-size: 14px;" @click="openDetail(scope.row)">查看</el-button>
												        <el-button type="text" size="small" :disabled="[2].indexOf(scope.row.status) != -1 || [8,9,10,11].indexOf(infoData.project.status) != -1" style="font-size: 14px;" @click="editDetailOpen(scope.row)">编辑</el-button>
												    </template>
												</el-table-column>
										</el-table>
									</div>
								</template>
							</div>
							<div class="whiteBox projectDetailBottom" v-if="infoData.chengben.length > 0">
								<el-tabs v-model="chengbenName">
								    <el-tab-pane label="利润变动" name="chengben">
										<div style="margin-top: 15px;">
											<el-table
												:data="infoData.chengben"
												style="width: 100%;"
												height="300"
												border
												stripe
												ref = "chengbentable">
											<el-table-column
													type=index
													label="序号"
													width="50">
											</el-table-column>
											<el-table-column
													prop="type"
													label="类型"
													width="100">
											</el-table-column>
											<el-table-column
													prop="code"
													label="编码"
													min-width="260">
											</el-table-column>
											<el-table-column
													prop="db_lr"
													label="利润对比"
													width="150">
													<template slot-scope="scope">
														<el-popover
														v-if="scope.row.type=='执行变动'"
														placement="top"
														width="880"
														trigger="hover">
														<el-table :data="scope.row.logs">
															<el-table-column width="180" property="create_time" label="创建日期"></el-table-column>
															<el-table-column width="100" property="company_service_rate" label="费率">
																<template slot-scope="scope">
																	{{ (scope.row.company_service_rate/100).toFixed(2) }}
																</template>
															</el-table-column>
															<el-table-column width="150" label="利润">
																<template slot-scope="scope">
																	<p>原：{{ scope.row.old_lr }}元</p>
																	<p>现：{{ scope.row.new_lr }}元</p>
																</template>
															</el-table-column>
															<el-table-column width="150" property="name" label="执行价">
																<template slot-scope="scope">
																	<p>原：{{ scope.row.old_strike_price }}元</p>
																	<p>现：{{ scope.row.new_strike_price }}元</p>
																</template>
															</el-table-column>
															<el-table-column width="150" label="返点">
																<template slot-scope="scope">
																	<p>原：{{ scope.row.old_point_price }}元</p>
																	<p>现：{{ scope.row.new_point_price }}元</p>
																</template>
															</el-table-column>
															<el-table-column width="150" label="报价">
																<template slot-scope="scope">
																	<p>原：{{ scope.row.old_quotation_price }}元</p>
																	<p>现：{{ scope.row.new_quotation_price }}元</p>
																</template>
															</el-table-column>
														</el-table>
														<p :style="{color:isColor(scope.row.db_lr),'font-weight':'bold'}" slot="reference">{{isUp(scope.row.db_lr)}}元</p>
														</el-popover>
														<span v-else :style="{'font-weight':'bold'}">{{isUp(scope.row.db_lr)}}元</span>
													</template>
											</el-table-column>
											<el-table-column
													label="利润"
													width="150">
													<template slot-scope="scope">
														<p>原：{{ scope.row.old_lr }}元</p>
														<p>现：{{ scope.row.new_lr }}元</p>
													</template>
											</el-table-column>
											<el-table-column
													label="执行价"
													width="150">
													<template slot-scope="scope">
														<p>原：{{ scope.row.old_strike_price }}元</p>
														<p>现：{{ scope.row.new_strike_price }}元</p>
													</template>
											</el-table-column>
											<el-table-column
													label="返点"
													width="150">
													<template slot-scope="scope">
														<p>原：{{ scope.row.old_point_price }}元</p>
														<p>现：{{ scope.row.new_point_price }}元</p>
													</template>
											</el-table-column>
											<el-table-column
													label="报价"
													width="150">
													<template slot-scope="scope">
														<p>原：{{ scope.row.old_quotation_price }}元</p>
														<p>现：{{ scope.row.new_quotation_price }}元</p>
													</template>
											</el-table-column>
											<el-table-column
													label="成本"
													width="150">
													<template slot-scope="scope">
														<p>原：{{ scope.row.old_zhichu }}元</p>
														<p>现：{{ scope.row.new_zhichu }}元</p>
													</template>
											</el-table-column>
											</el-table>
										</div>
									</el-tab-pane>
								</el-tabs>
							</div>
                        </div>
						<actionBar v-if="queryParams.type == 'approve' && infoData.project.project_name" :actioninfo="infoData" :loading.sync="loading"></actionBar>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
		<el-dialog
		  title="项目结算/合同"
		  :visible.sync="addVisible"
		  v-loading="loading"
		  width="70%">
		  <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
		  	<div>
		  		<el-form-item label="结算类型" prop="type">
		  			<el-radio-group v-model="addForm.type" @change="changeType()">
		  				<el-radio :label="5">开工证明</el-radio>
		  				<el-radio :label="6">项目单笔</el-radio>
						<el-radio :label="7">PO单</el-radio>
						<el-radio :label="8">确认邮件</el-radio>
						<el-radio :label="9">结算单</el-radio>
						<el-radio :label="10">结案报告</el-radio>
						<el-radio :label="11">其他结算证明</el-radio>	
		  			</el-radio-group>
		  		</el-form-item>
				<el-form-item label="编码" prop="po_num" v-if="addForm.type==7">
					<el-input v-model="addForm.po_num" placeholder="请输入编码" clearable></el-input>
				</el-form-item>
				<el-form-item :label="addForm.type==7?'合同名称':'关联合同'" prop="related_contracts_id">
				  <el-select v-model="addForm.related_contracts_id" filterable placeholder="请选择" style="width: 100%;" clearable @change="getInfo()">
				    <el-option
				      v-for="item in options.related_contracts_id_options"
				      :key="item.value"
					  :disabled="item.isCheck == 'NO'"
				      :label="item.label"
				      :value="item.value"
				    ></el-option>
				  </el-select>
				</el-form-item>
				<el-form-item label="附件" prop="attachments" v-if="addForm.type!=6">
					<el-upload
					  action
					  multiple
					  :file-list="addForm.attachments"
					  :on-remove="(file) => handleRemoveUpload(file, 'addForm','attachments',false)"
					  :auto-upload="false"
					  :on-change="(file) => changeRequired(file,'addForm','attachments',false)"
					  :on-preview="viewImg"
					>
					  <el-button slot="trigger" size="mini">选取文件</el-button>
					  <span style="margin-left: 10px; cursor: pointer;">
						  <el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
							<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
						  </el-tooltip>
					  </span>
					</el-upload>
				</el-form-item>
				<template v-if="addForm.type==6 && contractInfo.sign_start_end_time">
					<el-form-item label="合同金额">
						{{contractInfo.contract_amount}}
					</el-form-item>
					<el-form-item label="有效期">
						{{contractInfo.sign_start_end_time}}
					</el-form-item>
					<el-form-item label="签订日期">
						{{contractInfo.sign_time}}
					</el-form-item>
					<el-form-item label="是否锁价">
						{{contractInfo.is_lock}}
					</el-form-item>
					<el-form-item label="合同附件">
						<el-link type="primary" :href="contractInfo.attachment" target="_blank">附件</el-link>
					</el-form-item>
				</template>
		  	</div>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="addVisible = false" :size="size">取 消</el-button>
		    <el-button type="primary" @click="addContract()" :size="size">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		<el-dialog
		  title="查看-项目结算/合同"
		  :visible.sync="detailVisible"
		  width="70%">
		  	<div class="kContract">
				<el-form>
					<el-form-item label="合同类型:">
						{{detailInfo.type_txt}}
					</el-form-item>
					<el-form-item label="合同名称:">
						{{detailInfo.related_contracts_name}}
					</el-form-item>
					<el-form-item label="附件:" v-if="detailInfo.type != 6">
						<template v-if="detailInfo.attachment&&detailInfo.attachment.length>0">
							<span v-for="(item,index) in detailInfo.attachment" :key="index">
								<el-link type="primary" :href="item" target="_blank">附件{{index+1}}</el-link>{{index == detailInfo.attachment.length-1 ? '' : '、'}}
							</span>
						</template>
						<template v-else>
							暂无
						</template>
					</el-form-item>
					<template v-if="detailInfo.type == 6">
						<el-form-item label="合同金额">
							{{detailInfo.contract_amount}}
						</el-form-item>
						<el-form-item label="有效期">
							{{detailInfo.sign_start_end_time}}
						</el-form-item>
						<el-form-item label="签订日期">
							{{detailInfo.sign_time}}
						</el-form-item>
						<el-form-item label="是否锁价">
							{{detailInfo.is_lock}}
						</el-form-item>
						<el-form-item label="合同附件">
							<el-link type="primary" :href="detailInfo.attachment" target="_blank">附件</el-link>
						</el-form-item>
					</template>
				</el-form>
		  	</div>
		</el-dialog>
</div>
</template>
<script>
import actionBar from '../approve/Actionbar.vue';
import layoutStep from '../approve/Step.vue';
export default {
  props: ['info'],
  components: {
    layoutStep,
  	actionBar
  },
  data() {
      return {
		  chengbenName:'chengben',
		  show_summary:false,
          activeName: 'first',
          size:'mini',
		  loading:false,
		  addVisible:false,
		  detailVisible:false,
		  bottomActiveName:'',
		  resource_data:[],
		  infoData:{
			  chengben:[],
			  contract:[],
			  resource:[],
			  jingrong:[],
			  jingrong_other:[],
			  kaipiao:[],
			  project:{},
			  shoukuan:[],
			  step_info:{}
		  },
          tableData: {
              data: [],
			  otherdata:[]
          },
		  queryParams:'',//跳转页面携带参数
		  options:{
			  related_contracts_id_options:[]
		  },
		  dialogImageUrl:'',
		  dialogVisibleImg:false,
		  addForm:{
			  porject_id:'',
			  type:'',
			  attachments:[],
			  related_contracts_id:'',
			  po_num:''
		  },
		  rules: {
			addForm: {
				'type': [
					{required: true, message: '请选择类型', trigger: ['change', 'blur']}
				],
				'po_num': [
					{required: true, message: '请填写编码', trigger: ['change', 'blur']}
				],
				'related_contracts_id': [
					{required: true, message: '请选择合同', trigger: ['change', 'blur']}
				],
				'attachments': [
					{required: true, message: '请上传附件', trigger: ['change', 'blur']},
					{
					   validator: (rule, value, callback)=>{
							if (this.addForm.attachments.length == 0) {
								callback(new Error('请上传附件'));
							}else {
								callback();
							}
						}, trigger: ['change', 'blur']
					}
				],
			},
		  },
		  contractInfo:{},//合同项目单笔相关信息
		  detailInfo:{}//项目结算/合同查看详情数据
      }
  },
  computed: {
  },
  mounted: function () {
	  this.loading = true
	  this.queryParams = this.$route.query;
	  this.addForm.porject_id = this.queryParams.id
	  this.getDetail()
  },
  watch:{
	'bottomActiveName': {
		immediate: true,
		handler(newVal, oldVal) {
			if(newVal == 'resource'){
				this.show_summary = true
			}else{
				this.show_summary = false
			}
		},
		deep: true
	  },
  },
  methods: {
	isColor(text){
		if(text.includes('上升')){
			return '#67C23A'
		}else if(text.includes('下降')){
			return '#F56C6C'
		}else{
			return '#606266'
		}
	},
	isUp(val){
		if(val.includes('上升')){
			return val.replace("上升", "↑")
		}else if(val.includes('下降')){
			return val.replace("下降", "↓")
		}else{
			return val
		}
	},
	getSummaries(param){
		if(this.bottomActiveName == 'resource'){
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计:';
					return;
				}
				var fields = ['li_run','point_price','zhichu_price', 'baojia_chengbeng_price','quotation_price','strike_price','li_run_lv'];
				if (fields.indexOf(column.property) != -1){
					if (column.property == 'li_run_lv'){
						const values = data.map(item => Number(item['li_run']));
						var lirun_cost = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						const baojia_values = data.map(item => Number(item['quotation_price']));
						var baojia_cost = baojia_values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = baojia_cost > 0 ? (lirun_cost/baojia_cost*100).toFixed(2) + '%' : 0 + '%';
					}else{
						const values = data.map(item => Number(item[column.property]));
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = sums[index].toFixed(2) + ' 元';
					}
				}else{
					sums[index] = '';
				}
			});
			return sums;
		}else{
			return [];
		}
	},
	tableRowClassName({ row }) {
		if (row.li_run_lv.includes('-') || row.li_run.includes('-')) {
			return 'negative-row';
		}
		return '';
	},
	filterPaystatus (value, row) {
		return row.paystatus == value;
	},
	filterPointstatus (value, row) {
		return row.point_status == value;
	},
	filterinvoicestatus (value, row) {
		return row.invoicestatus == value;
	},
	filterPstatus(value, row) {
		return row.platform_status == value;	
	},
	filterPlatform(value, row){
		return row.is_platform_order == value;	
	},
	filterPoint(value, row){
		return row.is_point == value;	
	},
	filterTag(value, row) {
        return row.status == value;
    },
	editDetailOpen(row){
		this.$api.get('/admin/resources/resources/contractinfo',{id:row.id}).then(res => {
			if (res.code === 0) {
				this.$api.get('/admin/customers/customer/pcontractdw',{project_id:res.data.rid,type:res.data.type}).then(ress => {
					if (ress.code === 0) {
						this.options.related_contracts_id_options = ress.data
						this.addForm = {
							id:res.data.id,
							porject_id:res.data.rid,
							type:res.data.type,
							attachments:res.data.attachment,
							related_contracts_id:res.data.related_contracts,
							po_num:res.data.po_num_id
						}
					}
				})
				this.addVisible = true;
			} else {
				this.$message.error(res.msg);
			}
			this.loading = false
		})
	},
	
	  isColor(text){
	  	if(text.includes('上升')){
	  		return '#67C23A'
	  	}else if(text.includes('下降')){
	  		return '#F56C6C'
	  	}else{
	  		return '#606266'
	  	}
	  },
	  isUp(val){
	  	if(val.includes('上升')){
	  		return val.replace("上升", "↑")
	  	}else if(val.includes('下降')){
	  		return val.replace("下降", "↓")
	  	}else{
	  		return val
	  	}
	  },
		//获取详情
		getDetail(){
			let params={}
			params.id = this.queryParams.id
			if(this.queryParams.set_id){
				params.set_id = this.queryParams.set_id
			}
			if(this.queryParams.log_id){
				params.log_id = this.queryParams.log_id
			}
			this.$api.get('/admin/customers/customer/getexamineinfoview',params).then(res => {
				if (res.code === 0) {
					this.infoData = res.data
					this.bottomActiveName = 'resource'
					this.loading = false
				} else {
				  this.$message.error(res.msg);
				}
			})
		},
		goBack(){
			window.history.back()
		},
		//点击查看大图
		viewImg(file){
			if(!file.path){
				this.dialogImageUrl = URL.createObjectURL(file);
			}else{
				this.dialogImageUrl = file.path;
			}
			this.dialogVisibleImg = true;
		},
		//上传图片
		changeRequired(file, formobj, field, limitOne=true){
			if(limitOne){
				this[formobj][field] = [file.raw]
			}else{
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload(file,formobj,field,limitOne=true){
			if(limitOne){
				this[formobj][field] = []
			}else{
				this[formobj][field].forEach(function(item,index){
					if(item.name == file.name){
						this.$delete(this[formobj][field],index)
					}
				}.bind(this))
			}
		},
		addContract(){
			const formData = new FormData()
			for (const key in this.addForm) {
				if(key == 'attachments'){
					if (this.addForm[key].length > 0){
						this.addForm[key].forEach(item => {
							if(item.url){
								formData.append(key, JSON.stringify(item))
							}else{
								formData.append(key, item)
							}
						})
					}else{
						formData.append(key, '')
					}
				}else{
					formData.append(key, this.addForm[key]);
				}
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
				  this.loading = true;
				  if(this.addForm.id){
					this.$api.post('/admin/customers/customer/editprojectrcontract',formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.$message({
								showClose: true,
								message: '合同修改成功！',
								type: 'success'
							});
							this.getDetail();
							this.addVisible = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				  }else{
					this.$api.post('/admin/customers/customer/projectrcontract',formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.$message({
								showClose: true,
								message: '合同添加成功！',
								type: 'success'
							});
							this.getDetail();
							this.addVisible = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				  }
				  
				}
			}.bind(this));
		},
		addOpenInvoice(){
			this.addVisible = true;
			this.addForm.id = ''
			this.addForm.related_contracts_id = ''
			this.contractInfo={}
			this.addForm.po_num = ''
			this.addForm.attachments = []
			this.$nextTick(() => {
			  this.$refs['addForm'].clearValidate();
			});
		},
		changeType(){
			this.$api.get('/admin/customers/customer/pcontractdw',{project_id:this.addForm.porject_id,type:this.addForm.type}).then(res => {
			  if (res.code === 0) {
				  this.options.related_contracts_id_options = res.data
			  }
			})
		},
		getInfo(){
			if(this.addForm.related_contracts_id){
				this.options.related_contracts_id_options.forEach((item,index) => {
					if(item.value == this.addForm.related_contracts_id){
						this.contractInfo = item.info
					}
				})
			}
		},
		openDetail(item){
			this.detailInfo = item.contracts_info
			this.detailInfo.type = item.type
			this.detailInfo.type_txt = item.type_txt
			this.detailVisible = true
		}
  }
}
</script>
<style lang="scss" scoped>
.resourceCon{
	.addBox{
		margin-top: 60px;
	}
	.fyRadio{
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 20px;
			    height: 20px;
			    margin-right: 6px;
		}
		.fyRadioTitle{
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}
	.el-radio{
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}
.projectDetailTop{
	.title {
	    display: flex;
	    align-items: center;
	    height: 18px;
	    font-weight: 700;
		&:before {
			content: "";
			display: inline-block;
			width: 3px;
			border-radius: 15px;
			height: 100%;
			margin-right: 6px;
			background-color: #fe9027;
		}
	}
}
.projectDetailInfo{
	position: relative;
	padding-left: 60px;
	height: 100%;
	margin-top: 20px;
	padding-bottom: 10px;
	.base-info-wrap{
	    margin-bottom: 10px;
		.row{
		    display: flex;
		    font-size: 14px;
		    align-items: center;
			flex-wrap: wrap;
			.column{
			    width: 20%;
				padding-bottom: 14px;
				.column-label{
				    margin-right: 14px;
				    color: #a1a1a1;
				}
				.column-value {
				    word-break: break-all;
				    color: #333;
					&.red {
					    color: #fb5555 !important;
					    font-weight: 500;
					}
				}
			}
		}
	}
	.bg{
	    position: absolute;
	    top: 0;
	    left: -24px;
	    width: 36px;
	    height: 100%;
	    background: url(../../assets/images/titbg.png) no-repeat;
	    background-size: 100% 100%;
	    writing-mode: vertical-lr;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    padding-left: 6px;
	    font-size: 14px;
	    text-indent: 10px;
	    letter-spacing: 12px;
	    color: #775905ec;
		border-radius:8px;
		overflow: hidden;
	}
	.des{
	    position: relative;
	    color: #333;
	    background: #f9fafd;
	    border-radius: 8px;
	    padding: 6px 10px;
	    line-height: 30px;
	    margin-top: -14px;
	    font-size: 14px;
		div{
		    white-space: pre-wrap;
		}
		span{
		    font-weight: bolder;
		    white-space: nowrap;
		}
		.desdemand {
		    padding: 10px;
		}
	}
}
.kContract{
	.el-form-item{
		margin-bottom: 0 !important;
	}
}
.kNorwap{
	white-space: nowrap;
}
</style>